var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIndoor = function SvgIndoor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 20.035h-4.5a1.5 1.5 0 0 1-1.5-1.5v-7.5M.75 9.535l8.781-7.43a1.5 1.5 0 0 1 1.938 0l7.3 6.177M15.75 2.035h3v3M12.75 21.585v-4.9h.7a3.5 3.5 0 0 0 3.5-3.5 1.4 1.4 0 0 1 1.4-1.4 1.9 1.9 0 0 1 1.9 1.9v.9a.7.7 0 0 0 .7.7h.2a2.101 2.101 0 0 1 2.089 2.309l-.217 2.17a2.8 2.8 0 0 1-2.786 2.521h-2.894c-.26 0-.519-.036-.769-.108l-1.7-.484a2.778 2.778 0 0 0-.769-.108H12.75",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIndoor;